import { Header } from '../../../../components/common/table/Header/Header';
import { HeaderCell } from '../../../../components/common/table/HeaderCell/HeaderCell';
import '../List.scss';

export interface ListHeaderDoseEngineProps {}

export function ListHeaderDoseEngine() {
  return (
    <Header>
      <HeaderCell>{`Dose Engine `}</HeaderCell>
      <HeaderCell>{`date  (HH:MM:SS) `}</HeaderCell>
      <HeaderCell className="details-column">Actions</HeaderCell>
      <HeaderCell>{`Level`}</HeaderCell>
    </Header>
  );
}
